
import { defineComponent, ref, onBeforeMount } from 'vue';

export default defineComponent({
  name: 'AcreCookieConsent',
  props: {
    maxWidthContainer: {
      type: Number,
      default: 583,
    },
    linkText: {
      type: String,
      default: 'Learn More',
    },
    linkHref: {
      type: String,
      default: '/company/privacy',
    },
    message: {
      type: String,
      default: 'This site uses cookies to deliver its services and analyze traffic.',
    },
    dismissButtonText: {
      type: String,
      default: 'Ok. Got it.',
    },
    cookieName: {
      type: String,
      default: 'cookieconsent_status',
    },
    cookiePath: {
      type: String,
      default: '/',
    },
    cookieDomain: {
      type: String,
      default: '',
    },
    cookieExpiryDays: {
      type: Number,
      default: 365,
    },
  },
  emits: ['dismiss-cookie'],
  setup(props, { emit }) {
    const isShowPopup = ref(true);

    function escapeRegular(str: string) {
      return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
    }

    function getCookie(key: string, decoder = decodeURIComponent) {
      if ((typeof key !== 'string') || !key) {
        return null;
      }
      const reKey = new RegExp(`(?:^|; )${escapeRegular(key)}(?:=([^;]*))?(?:;|$)`);
      const match = reKey.exec(document.cookie);
      if (match === null) {
        return null;
      }
      return typeof decoder === 'function' ? decoder(match[1]) : match[1];
    }

    function setCookie(name: string, value: number, expiryDays: number, domain: string, path: string) {
      const exdate = new Date();
      exdate.setDate(exdate.getDate() + (expiryDays || 365));
      const cookie = [
        `${name}=${value}`,
        `expires=${exdate.toUTCString()}`,
        `path=${(path || '/')}`,
      ];
      if (domain) {
        cookie.push(`domain=${domain}`);
      }
      document.cookie = cookie.join(';');
    }

    function dismissCookie() {
      isShowPopup.value = false;
      emit('dismiss-cookie', isShowPopup.value);
      setCookie(props.cookieName, 1, props.cookieExpiryDays, props.cookieDomain, props.cookiePath);
    }

    onBeforeMount(() => {
      isShowPopup.value = !getCookie(props.cookieName);
    });
    return {
      isShowPopup,
      dismissCookie,
    };
  },
});
